import { createComponent as f, memo as u } from "solid-js/web";
import { createContext as y, useContext as m, createSignal as x, children as C } from "solid-js";
import T from "i18next";
const d = y();
function w(t, r) {
  const [e, n] = x(r.resources ? t.t : () => null);
  t.on("loaded", () => n(() => t.t)), t.init(r, (a, i) => n(() => i));
  async function o(a) {
    const i = await t.changeLanguage(a);
    n(() => i);
  }
  function c(a, i, h, s = {}) {
    return t.addResourceBundle(a, i, h, s.deep, s.overwrite);
  }
  return [(...a) => e().apply(null, a), {
    addResources: c,
    getI18next: () => t,
    changeLanguage: o
  }];
}
const I = () => m(d), R = (t) => f(d.Provider, {
  get value() {
    return w(t.instance || T, {
      lng: t.lng,
      ...t.options
    });
  },
  get children() {
    return t.children;
  }
}), l = (t, { prefix: r, suffix: e }) => t.includes(r) && t.includes(e), k = (t, { interpolation: r }) => (e, n) => {
  var o, c;
  return typeof e == "string" ? l(e, r) ? (o = t.children[n].children) == null ? void 0 : o[0].content : t.children[n].content : (e.textContent = (c = t.children[n].children) == null ? void 0 : c[0].content, e);
}, v = !globalThis.window, L = (t, r, e) => (n) => {
  const o = typeof n;
  if (o === "string" && l(n, r.interpolation))
    return t(n, e.options);
  if (o === "object") {
    const c = n.textContent ?? n.t;
    c && l(c, r.interpolation) && (n[v ? "t" : "textContent"] = t(c, e.options));
  }
  return n;
};
let g;
(async () => {
  try {
    g = (await import("html-parse-string")).parse;
  } catch {
  }
})();
const S = ({ i18n: { options: t }, t: r, props: e }, n) => {
  const o = r(e.key, e.options);
  if (!e.children)
    return o;
  if (o === e.key)
    return n.map(L(r, t, e));
  try {
    const [c] = g(`<0>${o}</0>`);
    return n.map(k(c, t));
  } catch {
    console.error(
      "In order to use JSX nesting, install %chtml-parse-string",
      "font-weight: 700",
      "https://github.com/ryansolid/html-parse-string."
    );
  }
}, X = (t) => {
  const [r, {
    getI18next: e
  }] = I();
  return u((() => {
    const n = u(() => typeof t.children == "string");
    return () => n() ? r(t.key, t.children, t.options) : S({
      i18n: e(),
      t: r,
      props: t
    }, C(() => t.children)());
  })());
};
export {
  X as Trans,
  R as TransProvider,
  I as useTransContext
};
